import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { DocumentUploadService } from '@xengage/gw-portals-document-js';

export default class GatewayClaimService {
    static getClaimDetail(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
            'getClaimDetail', [claimNumber], additionalHeaders);
    }

    static getClaimDetailSecure_Ext(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('claim'),
            'getClaimDetailSecure_Ext', [claimNumber], additionalHeaders);
    }

    static getClaimNotes(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
            'getClaimNotes', [claimNumber], additionalHeaders);
    }

    static createClaimNote(claimNumber, noteDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
            'createClaimNote', [claimNumber, noteDTO], additionalHeaders);
    }

    static updateClaimNote(claimNumber, note, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
            'updateClaimNote', [claimNumber, note], additionalHeaders);
    }

    static deleteClaimNote(claimId, noteId, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
            'deleteClaimNote', [claimId, noteId], additionalHeaders);
    }

    static getRecentlyViewedClaims(additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
            'getRecentlyViewedClaims', [], additionalHeaders);
    }

    static addRecentlyViewedClaim(claimNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
            'addRecentlyViewedClaim', [claimNumber], additionalHeaders);
    }

    static getClaimsForCurrentUser(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
            'getClaimsForCurrentUser', data, additionalHeaders);
    }

    static getOpenClaimsForCurrentUser(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
            'getOpenClaimsForCurrentUser', data, additionalHeaders);
    }

    static getAccountClaimsSecure_CPIC(accountNumber,queryOptions,queryParameters,nullparam, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
            'getAccountClaimsSecure_CPIC', [accountNumber,queryOptions,queryParameters,nullparam], additionalHeaders);
    }

    static getPolicyClaimsSecure_Ext(policyNumber,queryOptions,queryParameters, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
            'getPolicyClaimsSecure_Ext', [policyNumber,queryOptions,queryParameters], additionalHeaders);
    }

    static getClosedClaimsForCurrentUser(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
            'getClosedClaimsForCurrentUser', data, additionalHeaders);
    }

    static getClaimsForProducerCode(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
            'getClaimsForProducerCode', data, additionalHeaders);
    }

    static getOpenClaimsForProducerCode(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
            'getOpenClaimsForProducerCode_Ext', data, additionalHeaders);
    }

    static getClosedClaimsForProducerCode(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
            'getClosedClaimsForProducerCode', data, additionalHeaders);
    }

    static claimsDocUploadToken(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaimDocs'),
            'generateUploadToken',
            params, additionalHeaders);
    }

    static claimsRemoveDocument(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaimDocs'),
            'removeDocument',
            params, additionalHeaders);
    }

    static uploadDocument(file, documentMetadata, additionalHeaders = {}) {
        return DocumentUploadService.send(getProxiedServiceUrl('uploadDocument'), file, documentMetadata, additionalHeaders);
    }

    static requestReport(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
            'requestReport', data, additionalHeaders);
    }

    static reportStatus(data, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
            'reportStatus', data, additionalHeaders);
    }

    static lossRunRealTimeReport(reportDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
            'lossRunRealTimeReport', [reportDTO], additionalHeaders);
    }

    static getClaimsForDashboardSecure_Ext(claimStatus,parmsInput, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
            'getClaimsForDashboardSecure_Ext', claimStatus,parmsInput, additionalHeaders);
    } 
    
    static lossRunExtractRealTimeReport(reportDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('gatewayClaim'),
            'lossRunExtractRealTimeReport', reportDTO, additionalHeaders);
    }
}
